import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      {/* Top Info Bar */}
      <div className="top-bar">
        ग्रामपंचायत  आवळगांव | पंचायत समिती ब्रम्हपुरी, जि. चंद्रपूर
      </div>

      {/* Header */}
      <header className="header">
        <div className="header-inner">

          {/* LEFT EMPTY (balance) */}
          <div className="header-side"></div>

          {/* CENTER LOGO + TITLE */}
          <div className="header-center">
            <img
              src="/images/sj1.jpg"
              alt="राष्ट्रीय चिन्ह"
              className="emblem"
            />

            <div className="title-box">
              <h1>ग्रामपंचायत  आवळगांव</h1>
              <p>ISO 9001:2015 प्रमाणित</p>
            </div>
          </div>

          {/* RIGHT PERSONALITIES */}
          <div className="header-side personalities">
            {[
              "/images/raje.jpg",
              "/images/Gadgemaharaj.jpg",
              "/images/tujdojimaharaj.jpeg",
            ].map((img, i) => (
              <img key={i} src={img} alt="महापुरुष" />
            ))}
          </div>

          {/* Hamburger */}
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
        </div>

        {/* Navigation */}
        <nav className={`nav-bar ${menuOpen ? "open" : ""}`}>
          <Link to="/">मुख्य पृष्ठ</Link>
          <Link to="/aboutus">ग्रामपंचायत-बद्धल</Link>
          <Link to="/sachiv">ग्रामपंचायत-अधिकारी</Link>
          <Link to="/sarpanch">सरपंच</Link>
          <Link to="/upsarpanch">उपसरपंच</Link>
          <Link to="/team">सदस्य/कर्मचारी</Link>
          <Link to="/meeting">ग्रामसभा</Link>

          <div className="dropdown-wrapper">
            <span onClick={() => setOpen(!open)}>दाखले ▾</span>
            {open && (
              <div className="dropdown">
                <Link to="/janm-dakhala">जन्म दाखला</Link>
                <Link to="/mrut-dakhala">मृत्यू दाखला</Link>
                <Link to="/vivah-dakhala">विवाह दाखला</Link>
              </div>
            )}
          </div>

          <Link to="/devlopment">विकास कामे</Link>
          <Link to="/gallery">छायाचित्र</Link>
          <Link to="/contact">संपर्क</Link>
        </nav>
      </header>

      {/* CSS */}
      <style>{`
        body { margin:0 }

        .top-bar {
          background:#0b3d91;
          color:#fff;
          padding:6px 10px;
          font-size:14px;
          text-align:center;
          font-weight:600;
        }

        .header {
          background:#fff;
          box-shadow:0 4px 12px rgba(0,0,0,0.1);
          font-family:"Noto Sans Devanagari", sans-serif;
        }

        .header-inner {
          max-width:1300px;
          margin:auto;
          padding:15px 20px;
          display:flex;
          align-items:center;
          justify-content:space-between;
          position:relative;
        }

        .header-side {
          flex:1;
          display:flex;
          justify-content:flex-end;
          gap:8px;
        }

        /* CENTER SECTION */
        .header-center {
          flex:2;
          display:flex;
          flex-direction:column;
          align-items:center;
          text-align:center;
        }

        .emblem {
          height:65px;
          margin-bottom:6px;
        }

        .title-box {
          background:linear-gradient(135deg,#0b3d91,#138808);
          color:#fff;
          padding:8px 28px;
          border-radius:14px;
          box-shadow:0 6px 18px rgba(0,0,0,0.25);
        }

        .title-box h1 {
          margin:0;
          font-size:28px;
          font-weight:900;
          letter-spacing:1px;
        }

        .title-box p {
          margin-top:5px;
          font-size:14px;
          background:rgba(255,255,255,0.2);
          padding:4px 14px;
          border-radius:20px;
          display:inline-block;
        }

        /* PERSONALITIES */
        .personalities img {
          height:auto;
          width:65px;
          border-radius:50%;
          border:2px solid #0b3d91;
          object-fit:cover;
           top: 15px;
          right: 60px;
        }

        /* HAMBURGER */
        .hamburger {
          display:none;
          font-size:28px;
          cursor:pointer;
          color:#0b3d91;
          position:absolute;
          right:20px;
          top:20px;
        }

        /* NAV */
        .nav-bar {
          background:#f4f6fb;
          display:flex;
          justify-content:center;
          gap:10px;
          padding:10px;
          flex-wrap:wrap;
        }

        .nav-bar a, .nav-bar span {
          text-decoration:none;
          color:#0b3d91;
          font-weight:700;
          padding:6px 14px;
          border-radius:6px;
          cursor:pointer;
        }

        .nav-bar a:hover, .nav-bar span:hover {
          background:#0b3d91;
          color:#fff;
        }

        .dropdown-wrapper { position:relative; }

        .dropdown {
          position:absolute;
          top:36px;
          background:#fff;
          min-width:160px;
          border-radius:6px;
          box-shadow:0 6px 16px rgba(0,0,0,0.2);
          z-index:99;
        }

        .dropdown a {
          display:block;
          padding:8px 12px;
          color:#333;
        }

        .dropdown a:hover {
          background:#f0f2f8;
          color:#0b3d91;
        }

        /* MOBILE */
        @media (max-width:768px) {
          .personalities {
            display:none;
          }

          .hamburger {
            display:block;
          }

          .nav-bar {
            display:none;
            flex-direction:column;
            align-items:center;
          }

          .nav-bar.open {
            display:flex;
          }

          .title-box h1 {
            font-size:20px;
          }

          .emblem {
            height:50px;
          }
        }
      `}</style>
    </>
  );
};

export default Header;
